/**
 * @generated SignedSource<<c7bfb7613440e34064eb28a07f636115>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIGenerationReferenceListAssetDownloadUrlQuery$variables = {
  id: string;
};
export type AIGenerationReferenceListAssetDownloadUrlQuery$data = {
  readonly node: {
    readonly downloadUrl?: string;
  } | null;
};
export type AIGenerationReferenceListAssetDownloadUrlQuery = {
  response: AIGenerationReferenceListAssetDownloadUrlQuery$data;
  variables: AIGenerationReferenceListAssetDownloadUrlQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "downloadUrl",
      "storageKey": null
    }
  ],
  "type": "Asset",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AIGenerationReferenceListAssetDownloadUrlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AIGenerationReferenceListAssetDownloadUrlQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "64dbfb87f0a06027d96ddd24e308eece",
    "id": null,
    "metadata": {},
    "name": "AIGenerationReferenceListAssetDownloadUrlQuery",
    "operationKind": "query",
    "text": "query AIGenerationReferenceListAssetDownloadUrlQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Asset {\n      downloadUrl\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "80c35b4cf99466b97117d531970b9174";

export default node;
